import { Box, Button, Stack } from "@mui/material";
import { MaterialHotkeyOverlay } from "components/scrapEyeLayout/hotkeys/MaterialHotkeyOverlay";
import { useTenantTranslation } from "hooks/formatters";
import { MaterialRead } from "src/store/api/generatedApi";

type MaterialPickerProps = Readonly<{
  materials: readonly MaterialRead[];
  isEditMode: boolean;
  onClearMaterial: () => void;
  onCancel: () => void;
  selectedMaterialIndex?: number | null;
}>;

export const MaterialPicker = ({
  materials,
  isEditMode,
  onClearMaterial,
  onCancel,
  selectedMaterialIndex,
}: MaterialPickerProps) => {
  const { t } = useTenantTranslation();

  return (
    <Stack
      spacing={2}
      alignItems="center"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          maxWidth: "100%",
          overflow: "auto",
        }}
      >
        <MaterialHotkeyOverlay
          materials={materials}
          mode="compact"
          selectedMaterialIndex={selectedMaterialIndex}
        />
      </Box>
      <Stack direction="row" spacing={2}>
        {isEditMode ? (
          <Button
            variant="outlined"
            color="warning"
            size="small"
            onClick={onClearMaterial}
          >
            {t("clearMaterial")}
          </Button>
        ) : null}
        <Button
          variant="outlined"
          color="inherit"
          onClick={onCancel}
          startIcon={
            <Box
              component="span"
              sx={{
                px: 0.75,
                py: 0.25,
                bgcolor: "action.hover",
                borderRadius: 0.5,
                fontSize: "0.75rem",
                fontFamily: "monospace",
                fontWeight: "bold",
              }}
            >
              {t("escKey")}
            </Box>
          }
        >
          {t("cancel")}
        </Button>
      </Stack>
    </Stack>
  );
};
